<div class="overLayDiv active"></div>
<div id="rightSideBar">
    <div class="rightSidePanel active" style="z-index: 99999;">
        <header class="panel-header">
            <div class="viewDemo title-and-video">
                <h2>{{'select_state' | translate:param}}</h2>
            </div>            
            <div class="panel-left-btn">
                <button type="button" class="btn eod-btn-outline-warning" (click)="fnClosePanel()">
                    {{ 'label_close' | translate: param }}
                </button>
            </div>
        </header>
        <div class="eod-panel-body">
            <div class="block mt-2 padding-top-0 ">
                <div class="row margin-top-25">
                    <div class="col-lg-6 padding-left-0">
                        <div class="input-group">
                            <input type="text" class="form-control searchField" #searchField
                                [ngClass]="{ 'has-value': searchField.value }" name="searchText"
                                [(ngModel)]="searchText" autocomplete="off">
                            <label for="ExpenseCategory">{{ "label_search_criterion" | translate: param }}</label>
                            <span class="icons"><a>
                                    <i class="fas fa-search" aria-hidden="true"></i>
                                </a>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="block padding-top-10 heightCalc-12 overflow-auto scrollbar-visible">
                <div class="row">
                    <div class="col-lg-12 no-padding-right-left">
                        <div class="text-center noDataAvailable disabled opacity-60"
                            *ngIf="(stateList | grdFilter : {stateName: searchText}).length === 0">
                            {{ "no_data_available" | translate: param }}
                        </div>
                        <ul class="bulkList">
                            <li class="border-bottom padding-bottom-12  f-14 "
                                *ngFor="let item of stateList | grdFilter: { stateName: searchText}"
                                (click)="fnSelectStates(item)"
                                [ngClass]="{'active': item.stateId == selectedStateId }">
                                <span class="d-inline-block w-100pc text-ellipsis">{{item.stateName}}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
